import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a5e96da&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0a5e96da&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=0a5e96da&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5e96da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a5e96da')) {
      api.createRecord('0a5e96da', component.options)
    } else {
      api.reload('0a5e96da', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0a5e96da&scoped=true", function () {
      api.rerender('0a5e96da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/platList/index.vue"
export default component.exports